import { FormInput } from "./Common"
import { BaseOptionWithoutCode } from "./Option";
import OptionConst from '@/const/Option';

/**
 * セレクトボックス：雇用形態
 */
export interface KoyouType extends FormInput {
  id: number,
  code: string,
  label: string,
  type: string,
}

/**
 * 雇用契約：検索項目
 */
export interface SearchKoyouKeiyakuReq {
  koyou_keiyaku_id: number | null,    // 雇用契約ID
  staff_code: string | null,          // 社員番号
  staff_name: string | null,    // 氏名
  staff_kana: string | null,          // 氏名（カナ）
  mst_buka_id: number | null,   // 部課ID
  mst_syuugyou_basyo_id: number | null,   // 就業場所ID
  shinsei_type: number[],    // 申請種類種別 1:新規 2:更新 3:内容変更 4:入替
  koyou_type: number[],  // 雇用形態種別 1:月給 2:月給無期 3:時給 4:パート 5:パート無期
  keitai_type: number[], // 形態種別 1:正社員 2:契約社員 3:派遣 4:請負（フルタイム） 5:請負（パート）
  syounin_status_type: number[],  // 承認ステータス種別
  honnin_status_type: number[],   // 本人ステータス種別
  // 検索条件タイプ searchType 0:自由入力 1:契約期間終了1ヶ月前 2:入社後1ヶ月 3:社内承認 4:本人承認　5:編集中 6:マイタスク
  searchType: number,
  includeSakujo: boolean // 削除済みレコードを含むか
}

/**
 * 雇用契約：検索結果
 */
export interface SearchKoyouKeiyakuRes {
  koyou_keiyaku_id: number,    // 雇用契約ID
  status: string,    // ステータス   TODO:サーバー側で、本日日付から更新手続きの必要など算出して戻す？
  name: string,    // 氏名
  kana: string,          // 氏名（カナ）
  staff_code: string,          // 社員番号
  keiyaku_date: string | Date | null,        // 契約日（入社／変更日）
  koyou_end_date: string | Date | null,      // 雇用（試用）期間 終了日
  kinmu_status: number,   // 勤務状況種別 1:入社 2:産休中 3:育休中 4:休職 9:退職
  syuugyou_basyo: string,   // 就業場所
  buka: string,   // 部課
  keitai_type: number, // 形態種別 1:正社員 2:契約社員 3:派遣 4:請負（フルタイム） 5:請負（パート）
  koyou_type: number,  // 雇用形態種別 1:月給 2:月給無期 3:時給 4:パート 5:パート無期
  shinsei_type: number,    // 申請種類種別 1:新規 2:更新 3:内容変更 4:入替  
  syounin_status_type: number | null  // 承認ステータス種別
  honnin_status_type: number | null    // 本人ステータス種別
  syanai_notes: string,   // 備考
  user_id: number,    // ユーザーID
  syozoku_id: number, // 所属ID
  is_sakujo: boolean // 削除済
  is_changed: boolean // 変更済み
}

/**
 * 雇用契約就業時間
 */
export class KoyouKeiyakuTime {
  koyou_keiyaku_time_id: number | null = null;
  koyou_keiyaku_id: number | null = null; // この就業時間が適用される雇用契約のID
  start_time: Date | string = '09:00:00'; // 出勤時間
  end_time: Date | string = '18:00:00'; // 退勤時間
  kyuukei_times: Date | string = '01:00:00'; // 休憩時間
  tsuujou_times: Date | string = '08:00:00'; // 通常勤務時間（出勤-退勤-休憩）
  // 半日勤務有りフラグ
  // trueの場合は「半日勤務だけ」ではなく「終日勤務／半日勤務の両方が有りうる」ことを表現し、
  // falseの場合は「終日勤務のみ」を表現する。なお、can_only～の２フラグと両立することはない。
  is_hannichi = false; 
  // AM勤務のみ取得可フラグ（PM休しか取れない＝AM勤務しか無いことを表現するフラグ）
  // ※is_hannichi／can_only_pm_kinmuと両立することはない
  can_only_am_kinmu = false; 
  // PM勤務のみ取得可フラグ（AM休しか取れない＝PM勤務しか無いことを表現するフラグ）
  // ※is_hannichi／can_only_am_kinmuと両立することはない
  can_only_pm_kinmu = false; 
  is_himatagi = false; // 日跨ぎフラグ（未使用）
  is_monday = false; // この就業時間を適用する曜日フラグ（月曜）
  is_tuesday = false; // この就業時間を適用する曜日フラグ（火曜）
  is_wednesday = false; // この就業時間を適用する曜日フラグ（水曜）
  is_thursday = false; // この就業時間を適用する曜日フラグ（木曜）
  is_friday = false; // この就業時間を適用する曜日フラグ（金曜）
  is_saturday = false; // この就業時間を適用する曜日フラグ（土曜）
  is_sunday = false; // この就業時間を適用する曜日フラグ（日曜）
  weeks: string[] = []; // この就業時間を第何週に適用するかを保持（空の場合は毎週を指す）
}

/**
 * 雇用契約手当
 */
export class KoyouKeiyakuTeate {
  koyou_keiyaku_teate_id: number | null = null;
  koyou_keiyaku_id: number | null = null;
  mst_teate_id = 1;   // TODO:select-boxで選択した場合、stringになってしまう
  kingaku = 0;
  // ▽コンストラクタで引数を用いる場合？
  // constructor(koyouKeiyakuTeateId: number, koyouKeiyakuId: number) {
  //   this.koyou_keiyaku_teate_id = koyouKeiyakuTeateId;
  //   this.koyou_keiyaku_id = koyouKeiyakuId;
  // }
}

/**
 * 変更前雇用契約書の情報（内容変更などの承認後に削除フラグを立てる予定の雇用契約書を保存）
 */
export class KoyouKeiyakTsuiseki {
  koyou_keiyaku_tsuiseki_id: number | null = null
  old_koyou_keiyaku_id: number | null = null
  new_koyou_keiyaku_id: number | null = null
  is_main: boolean = false
}

/**
 * 就業場所
 */
export interface SyuugyouBasyo {
  mst_syuugyou_basyo_id: number | null,
  syuugyou_basyo_name: string,
  syuugyou_basyo_kana: string | null,
  syuugyou_basyo_address: string,
  syuugyou_basyo_tel: string,
  mst_buka_id: number | null,
}

export interface UpsertSyuugyouBasyoRes {
  result: boolean,
  message: string,
  bukaId: number | null
}

export interface DeleteSyuugyouBasyoRes {
  result: boolean,
  message: string,
}


/**
 * 部課
 */
export interface Buka {
  mst_buka_id: number | null,
  mst_syozoku_id: number | null,
  buka_code: string | null,
  buka_name: string | null,
  buka_kana: string | null,
}

/**
 * オプション
 */
export interface KoyouKeiyakuOption {
  syozoku: BaseOptionWithoutCode[],  // 所属会社
  buka: BaseOptionWithoutCode[],  // 部課
  teate: BaseOptionWithoutCode[],  // 手当
  syuugyou_basyo: BaseOptionWithoutCode[],  // 就業場所
  shinsei_type: BaseOptionWithoutCode[],    // 申請種類種別
  koyou_type: BaseOptionWithoutCode[],    // 雇用形態種別
  keitai_type: BaseOptionWithoutCode[],    // 形態種別
  kyoutei_type: BaseOptionWithoutCode[],    // 協定派遣労働者フラグ
  shime_day_type: BaseOptionWithoutCode[],    // 締め日
  boolean_type: BaseOptionWithoutCode[],    // 有無タイプ
  pay_day: number,    // 支払日
  dakoku_round: BaseOptionWithoutCode[],     // 打刻丸め分数
  minutes_in_hour_round: BaseOptionWithoutCode[],    // 所定労働時間（週）の分数の刻み
  syounin_status_type: BaseOptionWithoutCode[],      // 承認ステータスタイプ
  honnin_status_type: BaseOptionWithoutCode[],      // 本人ステータスタイプ
  search_type: BaseOptionWithoutCode[],      // 検索条件タイプ
  eigyou_users: BaseOptionWithoutCode[],  // 営業担当
  kinmu_status: BaseOptionWithoutCode[],  // 営業担当
}

export interface KoyouKeiyakuAgreementReq {
  koyouKeiyakuId: number,
  status: number,
  notes: string | null
}

export interface KeiyakuDetailWithSyuugyouBasyoAndBuka {
  koyou_keiyaku_id: number,
  syozoku_id: number | null,
  shinsei_type: number | null,
  koyou_type: number | null,
  keitai_type: number | null,
  name: string | null,
  kana: string | null,
  user_id: number | null,
  change_user_id: number | null,
  hikitsugi_end_date: string | Date | null,
  seikyu_start_date: string | Date | null,
  is_kyoutei: boolean,
  kyoutei_end_date: null,
  keiyaku_date: string | Date | null,
  koyou_end_date: string | Date | null,
  mst_syuugyou_basyo_id: number | null,
  work_detail1: string | null,
  work_detail2: string | null,
  syotei_work_week_times: string | Date | null
  syotei_work_month_times: number | null,
  syotei_work_week_days: number | null,
  kihonkyuu: number | null,
  is_jikyuu: boolean,
  zangyou_mikomi: number | null,
  shime_day: number | null,
  pay_day: number | null,
  koutsuuhi: number | null,
  koutsuuhi_kazei: number | null,
  is_koyou_hoken: boolean,
  is_syakai_hoken: boolean,
  yuukyuu_days: number | null,
  sashihiki_times: string | Date | null
  is_syouyo: boolean,
  is_syoukyuu: boolean,
  is_taisyokukin: boolean,
  kyujitsu_zougen_notes: string | null,
  jikangai_notes: string | null,
  is_jikangai: boolean,
  is_keiyaku_koushin: number | null,
  honnin_notes: string | null,
  syanai_notes: string | null,
  submitted_date: string | Date | null,
  submitted_user_id: null,
  houkatsu_times: string | Date | null
  syounin_status_type: number | null,
  honnin_status_type: number | null,
  fusaiyou_notes: string | null,
  is_sakujo: boolean,
  eigyou_user_id: number | null,
  is_changed: boolean,
  syuugyou_basyo_name: string | null,
  syuugyou_basyo_address: string | null,
  syuugyou_basyo_tel: string | null,
  mst_buka_id: number | null,
  mst_syozoku_id: number | null,
  buka_code: string | null,
  buka_name: string | null,
}